(() => {
  if (window.__kkJul2026ValidationInstalled) return;
  window.__kkJul2026ValidationInstalled = true;
  const fieldSelector = '[data-kk-jul-2026-input]';
  const normalize = (value) => String(value ?? '').trim().toLocaleLowerCase('nb-NO');
  let pendingInvalidFocus = null;

  const containers = (root = document) => {
    const matches = new Set(root.matches?.('product-info') ? [root] : []);
    const parent = root.closest?.('product-info');
    if (parent) matches.add(parent);
    root.querySelectorAll?.('product-info').forEach((info) => matches.add(info));
    return Array.from(matches).filter((info) => info.querySelector(fieldSelector));
  };

  const optionValue = (info, position) => {
    const groups = info.querySelectorAll('variant-selects .product-form__input');
    const control = groups[position - 1]?.querySelector('select, input:checked');
    if (control) return control.value;
    const selected = info.querySelector('variant-selects [data-selected-variant]');
    try {
      return JSON.parse(selected?.textContent || 'null')?.options?.[position - 1] ?? null;
    } catch (_) {
      return null;
    }
  };

  const updateCounter = (field) => {
    const counter = field.closest('.kk-jul-2026-control')?.querySelector('[data-kk-jul-2026-counter]');
    if (counter?.dataset.kkJulCounterTemplate) {
      counter.textContent = counter.dataset.kkJulCounterTemplate.replace('[count]', String(field.value.length));
    }
  };

  const clearError = (field) => {
    field.setCustomValidity('');
    field.setAttribute('aria-invalid', 'false');
    const control = field.closest('.kk-jul-2026-control');
    control?.classList.remove('kk-jul-2026-invalid');
    const error = control?.querySelector('.kk-jul-2026-error');
    if (error) error.hidden = true;
  };

  const isOverLimit = (field) => field.maxLength >= 0 && field.value.length > field.maxLength;
  const isInvalid = (field) => !field.value.trim() || isOverLimit(field);

  const showError = (field) => {
    const messageAttribute = isOverLimit(field)
      ? 'data-kk-jul-2026-limit-message'
      : 'data-kk-jul-2026-required-message';
    const message = field.getAttribute(messageAttribute) || field.validationMessage;
    field.setCustomValidity(message);
    field.setAttribute('aria-invalid', 'true');
    const control = field.closest('.kk-jul-2026-control');
    control?.classList.add('kk-jul-2026-invalid');
    const error = control?.querySelector('.kk-jul-2026-error');
    if (error) {
      error.textContent = message;
      error.hidden = false;
    }
  };

  const focusField = (field) => {
    const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    field.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'center' });
    field.focus({ preventScroll: true });
  };

  const sync = (info) => {
    if (!info?.querySelector(fieldSelector)) return;
    info.querySelectorAll('[data-kk-jul-variant-condition]').forEach((wrapper) => {
      const position = Number(wrapper.dataset.kkJulVariantPosition || 1);
      const selected = optionValue(info, position);
      if (selected == null) return;
      const shouldShow = normalize(selected) === normalize(wrapper.dataset.kkJulVariantCondition);
      wrapper.hidden = !shouldShow;
      wrapper.querySelectorAll(fieldSelector).forEach((field) => {
        field.disabled = !shouldShow;
        field.required = shouldShow;
        field.setAttribute('aria-required', String(shouldShow));
        if (shouldShow) {
          field.setAttribute('form', field.dataset.kkJulFormId || `product-form-${info.dataset.section}`);
        } else {
          field.removeAttribute('form');
          clearError(field);
        }
      });
    });
    info.querySelectorAll(fieldSelector).forEach(updateCounter);
  };

  const boot = (root = document) => containers(root).forEach(sync);
  const isActive = (field, form) => field.form === form && field.required && !field.disabled &&
    !field.closest('[data-kk-jul-2026-fields]')?.hidden;

  document.addEventListener('invalid', (event) => {
    const field = event.target;
    if (!field.matches?.(fieldSelector) || !field.form || !isActive(field, field.form)) return;
    event.preventDefault();
    showError(field);
    if (pendingInvalidFocus) return;
    pendingInvalidFocus = field;
    queueMicrotask(() => {
      focusField(pendingInvalidFocus);
      pendingInvalidFocus = null;
    });
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !new URL(form.action).pathname.match(/\/cart\/add(?:\.js)?\/?$/)) return;
    const info = form.closest('product-info');
    if (!info?.querySelector(fieldSelector)) return;
    sync(info);
    const fields = Array.from(info.querySelectorAll(fieldSelector)).filter((field) => isActive(field, form));
    const invalid = fields.filter(isInvalid);
    fields.forEach((field) => invalid.includes(field) ? showError(field) : clearError(field));
    if (!invalid.length) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    focusField(invalid[0]);
  }, true);

  document.addEventListener('input', (event) => {
    const field = event.target;
    if (!field.matches?.(fieldSelector)) return;
    updateCounter(field);
    if (isOverLimit(field)) showError(field);
    else if (!isInvalid(field)) clearError(field);
  }, true);

  document.addEventListener('change', (event) => {
    if (event.target.matches?.(fieldSelector)) {
      updateCounter(event.target);
      if (isOverLimit(event.target)) showError(event.target);
      else if (!isInvalid(event.target)) clearError(event.target);
      return;
    }
    const info = event.target.closest?.('variant-selects')?.closest('product-info');
    if (info) sync(info);
  }, true);

  const syncVariantFields = (event) => {
    const info = event.target.closest?.('product-info');
    if (info) sync(info);
  };
  document.addEventListener('kk:variant-selection-committed', syncVariantFields);
  document.addEventListener('kk:variant-selection-restored', syncVariantFields);

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
      containers().filter((info) => [info.dataset.section, info.dataset.originalSection].includes(data.sectionId))
        .forEach(sync);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot(), { once: true });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
  new MutationObserver((changes) => {
    const affected = new Set();
    changes.forEach((change) => {
      change.addedNodes.forEach((node) => {
        if (node instanceof Element) containers(node).forEach((info) => affected.add(info));
      });
    });
    affected.forEach(sync);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

